import { ButtonInterface } from 'common/types/entities/button-interface'
import React from 'react'
import { CommonButtonSettings } from '../common-button-settings'

interface RegistrationButtonSettingsProps {
  entity: ButtonInterface
  defaultEntity?: ButtonInterface
}

export const RegistrationButtonSettings = ({
  entity,
  defaultEntity,
}: RegistrationButtonSettingsProps) => {
  return <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
}
